import DetailsCard from './cards/DetailsCard';
import HandedOffCard from './cards/HandedOffCard';
import type { TimeRuleChat } from './useTimeRuleChat';
import type { TimeRuleStepKind } from './types';

export default function TimeRuleCard({ step, chat }: { step: TimeRuleStepKind; chat: TimeRuleChat }) {
	if (step !== chat.step) {
		return null;
	}
	return step === 'details' ? <DetailsCard chat={chat} /> : <HandedOffCard chat={chat} />;
}
